export default __webpack_public_path__ + "static/media/switchoff1.19eae96e.wav";